import ensureWebComponentsInit from '@boschebike/ebds-js/dist-esm/helpers/ensureWebComponentsInit.js';
import { registerAll } from '../register-webcomponents.js';

import { Dodo } from '../dodo.js';
import { GoogleAnalytics } from '../google-analytics.js';

/**
 *
 * @param {Record<string, any>} props
 */
export const initGlobals = (props) => {
  ensureWebComponentsInit();

  // Dodo api
  window.dodo = new Dodo();
  // Must be after Dodo init!
  registerAll();

  const { googleAnalyticsId, googleAnalyticsConsentType } = props?.meta ?? {};
  if (googleAnalyticsId) {
    // eslint-disable-next-line no-new
    new GoogleAnalytics(googleAnalyticsId, googleAnalyticsConsentType); // NOSONAR
  } else {
    window.dataLayer = [];
  }
};
